<template>
  <div class="wt-timeline-zoom">
    <i
      class="wticon wticon-minus1 -zoom-out"
      :class="{ disabled: cantZoomOut }"
      title="Zoom Out"
      @click="onZoomOut"
    />
    <input
      ref="elInput"
      type="range"
      min="0"
      :max="maxZoomIndex"
      :value="curZoomIndex"
      id="zoomSlider"
      title="Zoom Timeline"
      tabstop="0"
      @focus="onFocusBlur"
      @input="onInputChange"
    />
    <i
      class="wticon wticon-plus -zoom-in"
      :class="{ disabled: cantZoomIn }"
      title="Zoom In"
      @click="onZoomIn"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import app from 'app';
import storyViewBus from '../storyViewBus';

export default Vue.extend({
  name: 'wt-timeline-zoom',

  data() {
    return {
      isBusy: false,
    };
  },

  computed: {
    cantZoomOut() {
      return this.isBusy || this.curZoomIndex <= 0;
    },

    cantZoomIn() {
      return (
        this.isBusy || this.curZoomIndex >= this.timelineZoom.steps.length - 1
      );
    },

    maxZoomIndex() {
      return this.timelineZoom.steps.length - 1;
    },

    curZoomIndex() {
      return this.timelineZoom.steps.indexOf(this.timelineZoom.rowDuration);
    },

    ...mapState({
      timelineZoom: (state) => state.story.timelineZoom,
    }),
  },

  beforeDestroy() {
    app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.TIBTZ);
  },

  mounted() {
    app.keyboardAccessibility.add(app.KEYBOARD_LAYER.TIBTZ, [
      {
        on: 'keyup',
        key: 187 /* plus*/,
        stash: 1,
        run: this.onKeyboardEvent,
      },
      {
        on: 'keyup',
        key: 189 /* minus*/,
        stash: -1,
        run: this.onKeyboardEvent,
      },
      {
        on: 'keyup',
        key: 107 /* numpad plus*/,
        stash: 1,
        run: this.onKeyboardEvent,
      },
      {
        on: 'keyup',
        key: 109 /* numpad minus*/,
        stash: -1,
        run: this.onKeyboardEvent,
      },
    ]);
  },

  methods: {
    onFocusBlur(e) {
      e.target.blur();
    },

    onKeyboardEvent(e, stash) {
      if (!e.ctrlKey && !e.metaKey) {
        if (stash > 0) {
          this.onZoomIn();
        } else {
          this.onZoomOut();
        }
      }
    },

    onInputChange() {
      if (this.isBusy) {
        return;
      }

      const index = parseInt(this.$refs.elInput.value, 10);
      const rowDuration = this.timelineZoom.steps[index];
      this.$_performZoom(rowDuration);
    },

    onZoomOut() {
      if (this.cantZoomOut) {
        return;
      }

      const index = parseInt(this.$refs.elInput.value, 10);
      const rowDuration = this.timelineZoom.steps[index - 1];
      this.$_performZoom(rowDuration);
    },

    onZoomIn() {
      if (this.cantZoomIn) {
        return;
      }

      const index = parseInt(this.$refs.elInput.value, 10);
      const rowDuration = this.timelineZoom.steps[index + 1];
      this.$_performZoom(rowDuration);
    },

    $_performZoom(rowDuration) {
      this.isBusy = true;
      storyViewBus.$emit('svbTimelineZoom', { rowDuration }, () => {
        this.$store.commit('setTimelineZoom', { rowDuration });
        this.isBusy = false;
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.wt-timeline-zoom {
  display: flex;
  height: 30px;
  padding: 0;
  align-items: center;
  user-select: none;

  i {
    font-size: 14px;
    font-weight: 600;
    padding: 6px;
    color: $color-normal;
    cursor: pointer;

    &:hover {
      color: $color-black;
    }

    &.disabled {
      pointer-events: none;
      color: $color-grey-2;
      cursor: default;
    }
  }

  .-zoom-out {
    padding-left: 0;
  }

  input[type='range'] {
    -webkit-appearance: none;
    width: 102px;
    height: 20px;
    cursor: pointer;
    margin: 0 8px;
    background: transparent;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.12);
      background-color: $color-primary;
      cursor: pointer;
      transform: translateY(-6px);
      box-shadow: 0 1px 1px 0 $color-grey-2;
    }

    &::-webkit-slider-runnable-track {
      width: 60px;
      height: 2px;
      background-color: #bdc3c7;
      border: none;
      border-radius: 2px;
    }

    &:hover::-webkit-slider-runnable-track {
      background-color: darken(#bdc3c7, 5%);
    }
  }
}
</style>
